// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"0":"codemirror","3":"react-movable","4":"react-sortable-hoc"}[chunkId] || chunkId) + ".min.js?" + {"0":"69f626f812e3ea28d3d8","3":"6b22b5424288b41e48c6","4":"698e9a7caca046b2d10f","5":"208edfdaba0effa9deea"}[chunkId] + "";
};